// System dependencies

import React from 'react';

// Application dependencies

import { FormSpinnerRedux } from '@/interfaces/formSpinner.interfaces';

// Props

const FormSpinner: React.FC<FormSpinnerRedux> = ({ caption, isActive }) => {
  return !isActive ? null : (
    <div className="fixed left-0 right-0 z-50 flex h-screen flex-col items-center justify-center bg-background/90">
      <div className="flex flex-col items-center">
        <div className="relative h-16 w-16">
          <div className="absolute h-full w-full rounded-full border-4 border-solid border-zinc-300 dark:border-zinc-700"></div>
          <div className="absolute h-full w-full animate-spin rounded-full border-4 border-solid border-zinc-700 border-t-transparent dark:border-zinc-300 dark:border-t-transparent"></div>
        </div>
        {caption?.trim() && <div className="font-xl mt-2 text-center">{caption}</div>}
      </div>
    </div>
  );
};

export default FormSpinner;
